export default function OnlinePay(props) {
    return (
        <ul>
            <li title={props.title}>
                {props.link !== '/' ? 
                    <a href={props.link}>
                        <img width={'20'} src={require(`../../docs/pays/${props.img}`)} />
                    </a>
                :
                props.img
                }
            </li>
        </ul>
    )
}